export default {
      id: "ic-plan-loisirs-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-loisirs-usage",
      toString: function () {
        return this.url;
      }
    }